module.exports = __webpack_public_path__ + "static/media/cake.662725ae.png";